import {viewModel as SwitchViewModel} from "./switch";
import checkboxHtml from './checkbox.html?raw';

export let template: string = checkboxHtml;

export class viewModel extends SwitchViewModel {
}
